import { Link } from "react-router";
import { MAIN_NAV } from "../../Config/nav";
import { Button } from "react-bootstrap";

export default function Home() {
  return (
    <div className="home">
      <div className="home-content">
        <div>
          <h1>
            <img
              src="/images/logo.svg"
              alt="Liberty Connect Logo"
              className="logo"
            />
          </h1>
          <h2>Empowerment Through Knowledge & Connections</h2>
        </div>
        <Link to="/membership">
          <Button variant="primary" size="lg">
            Sign Up - Free Trial
          </Button>
        </Link>
        <ul>
          {MAIN_NAV.map((nav) => (
            <li key={nav.label}>
              <Link to={nav.link}>{nav.label}</Link>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
